import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "@/plugins/firebase";
import axios from "axios";

Vue.use(VueRouter);

const DEFAULT_TITLE = "UTEx";

const routes = [
  {
    path: "*",
    name: "not-found",
    component: () => import("../views/404.vue")
  },
  {
    path: "/",
    component: () => import("../layouts/home/Index.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/home/Index.vue")
      },
      {
        path: "/about",
        name: "about",
        component: () => import("../views/About.vue")
      },
      {
        path: "/catalog",
        name: "catalog",
        component: () => import("../views/catalog/Index.vue")
      },
      {
        path: "/certification",
        name: "certification",
        component: () => import("../views/Certification.vue")
      },
      {
        path: "/catalog/:courseUrlCode",
        name: "catalog-detail",
        component: () => import("../views/catalog/Detail.vue")
      },
      {
        path: "/terms-of-use",
        name: "terms-of-use",
        component: () => import("../views/TermsOfUse.vue")
      },
      {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: () => import("../views/PrivacyPolicy.vue")
      },
      {
        path: "/personal-data-protection",
        name: "personal-data-protection",
        component: () => import("../views/PersonalDataProtection.vue")
      },
      {
        path: "/shopping-cart",
        component: () => import("../layouts/shopping-cart/Index.vue"),
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: "",
            name: "shopping-cart-index",
            component: () => import("../views/shopping-cart/Index.vue"),
            meta: {
              requiresAuth: true
            }
          },
          {
            path: "payment",
            name: "shopping-cart-payment",
            component: () => import("../views/shopping-cart/Payment.vue"),
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ]
  },
  {
    path: "/shopping-cart/result/:orderId",
    name: "shopping-cart-result",
    component: () => import("../views/shopping-cart/Result.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "",
    component: () => import("../layouts/account/Index.vue"),
    children: [
      {
        path: "/signin",
        name: "signin",
        component: () => import("../views/account/SignIn.vue")
      },
      {
        path: "/signup",
        name: "signup",
        component: () => import("../views/account/SignUp.vue")
      },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import("../views/account/ForgotPassword.vue")
      }
    ]
  },
  {
    path: "/classroom",
    component: () => import("../layouts/classroom/Index.vue"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "classroom",
        component: () => import("../views/classroom/Index.vue"),
        meta: {
          title: "Eğitimlerim",
          requiresAuth: true
        }
      },
      {
        path: "settings",
        name: "settings",
        component: () => import("../views/classroom/Settings.vue"),
        meta: {
          title: "Ayarlar",
          requiresAuth: true
        }
      },
      {
        path: "orders",
        name: "orders",
        component: () => import("../views/classroom/Orders.vue"),
        meta: {
          title: "Sipariş Geçmişi",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/course/:courseUrlCode",
    component: () => import("../layouts/course/Index.vue"),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "",
        name: "course-home",
        component: () => import("../views/course/Index.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "lessons",
        name: "course-lessons",
        component: () => import("../views/course/Lessons.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "discussions",
        name: "course-discussions",
        component: () => import("../views/course/discussions/Index.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "discussions/:id",
        name: "course-discussion",
        component: () => import("../views/course/discussions/View.vue"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // Set page title
  document.title = to.meta.title
    ? to.meta.title + " - " + DEFAULT_TITLE
    : DEFAULT_TITLE;

  // Check requires auth
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Get current user
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next();
      } else {
        next({
          name: "signin",
          query: { returnUrl: to.path }
        });
      }
    });
  } else {
    next();
  }
});

router.afterEach(to => {
  // If the main menu has been opened, close it
  const body = document.querySelector("body");
  if (body != null) {
    body.classList.remove("menu-opened");
  }

  // Set page loader
  setTimeout(() => {
    setPageLoaded();
  }, 1000);

  // If user signed in, log the request
  firebase.auth().onAuthStateChanged(async user => {
    if (user) {
      try {
        // Get user ipinfos
        const ipInfoResponse = await axios.get(
          `https://ipinfo.io/json?token=d2efacd0f64aa6`
        );
        let client = ipInfoResponse.data;

        await firebase
          .firestore()
          .collection("logs")
          .add({
            user: {
              uid: user.uid,
              email: user.email,
              displayName: user.displayName
            },
            route: {
              path: to.fullPath,
              params: to.params,
              title: !to.meta.title ? null : to.meta.title
            },
            client: client,
            date: new Date(Date.now())
          });
      } catch (error) {
        throw `Logging failed: ${error}`;
      }
    }
  });
});

const setPageLoaded = () => {
  const body = document.getElementsByTagName("body")[0];
  body.classList.add("page-loaded");
};

export default router;
